export class LatestRafScheduler {
  private _rafId: number | null = null;
  private _epoch = 0;
  private _destroyed = false;

  nextEpoch() {
    return ++this._epoch;
  }

  isCurrent(epoch: number) {
    return !this._destroyed && epoch === this._epoch;
  }

  schedule(epoch: number, callback: () => void) {
    if (this._destroyed) return;

    this.cancelPendingFrame();

    this._rafId = requestAnimationFrame(() => {
      this._rafId = null;
      if (!this.isCurrent(epoch)) return;
      callback();
    });
  }

  cancelPendingFrame() {
    if (this._rafId === null) return;
    cancelAnimationFrame(this._rafId);
    this._rafId = null;
  }

  destroy() {
    this._destroyed = true;
    this.cancelPendingFrame();
  }
}
